import { last } from '../helper/array';
import { pathSegments, getter, setter } from '../helper/accessors';
import { hasValue } from 'utils/helper/type';

export class Storage {
  constructor(storageKey, storage = globalThis.localStorage) {
    this.storageKey = storageKey;
    this.storage = storage;
  }

  set(key, value) {
    if (hasValue(value)) {
      const root = this.getRoot();
      setter(root, key, value);
      this.setRoot(root);
    } else {
      this.clear(key);
    }
  }

  get(key) {
    const root = this.getRoot();

    return getter(root, key);
  }

  setRoot(value) {
    this.storage.setItem(this.storageKey, JSON.stringify(value));
  }

  getRoot() {
    const root = this.storage.getItem(this.storageKey);
    const rootObj = root ? JSON.parse(root) : {};

    return rootObj;
  }

  clear(path) {
    if (!path) {
      this.storage.removeItem(this.storageKey);
      return;
    }
    const root = this.getRoot();
    const segments = pathSegments(path);
    let parentPath = segments;
    let parent;

    do {
      const field = last(parentPath);
      parentPath = parentPath.slice(0, -1);
      parent = getter(root, parentPath);
      if (parent) {
        delete parent[field];
      }
    } while (parent && parentPath.length && !Object.keys(parent).length);

    if (!parentPath.length) {
      if (!parent || Object.keys(parent).length === 0) {
        this.storage.removeItem(this.storageKey);
      } else {
        this.setRoot(parent);
      }
    } else {
      this.set(parentPath, parent);
    }
  }
}
